import { setupLayouts } from 'virtual:meta-layouts'
import type { App } from 'vue'

import type { RouteRecordRaw } from 'vue-router/auto'

import { createRouter, createWebHistory } from 'vue-router/auto'
import { setupGuards } from './guards'

/**
 * Aplica el layout a cada ruta.
 *
 * La versión de la plantilla bajaba siempre hasta las hojas, porque asumía que
 * un registro con hijas es solo un tramo de path sin componente (lo que genera
 * `unplugin-vue-router` para carpetas como `dive-centers/[id]/`).
 *
 * Con `profile.vue` + `profile/` eso dejó de ser cierto: ahí el padre **sí**
 * tiene componente y hace de layout de sección. Envolviendo las hojas, el
 * layout se dibujaba dos veces — navbar y sidebar aparecían de nuevo dentro
 * del `RouterView` del padre. Cuando el registro tiene componente propio, el
 * layout lo envuelve a él y las hijas se quedan como están.
 */
function recursiveLayouts(route: RouteRecordRaw): RouteRecordRaw {
  if (route.component && route.children?.length)
    return setupLayouts([route])[0]

  if (route.children) {
    for (let i = 0; i < route.children.length; i++)
      route.children[i] = recursiveLayouts(route.children[i])

    return route
  }

  return setupLayouts([route])[0]
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash)
      return { el: to.hash, behavior: 'smooth', top: 60 }

    return { top: 0 }
  },
  extendRoutes: pages => [
    ...[...pages].map(route => recursiveLayouts(route)),
  ],
})

setupGuards(router)

export { router }

export default function (app: App) {
  app.use(router)
}
